module.exports = __webpack_public_path__ + "img/ico_select_active.23610ba2.svg";